import React from "react";
import { PiFileArrowDown } from "react-icons/pi";
import "./GuiaButton.css";

const GuiaButton = ({ href, children }) => (
  <a href={href} target="_blank" rel="noopener noreferrer" className="guia-btn">
    <PiFileArrowDown className="guia-btn-icon" />
    <span className="guia-btn-text">{children}</span>
  </a>
);

export default GuiaButton;
